<div
  fxLayout="row"
  fxLayoutAlign="center center"
  class="directions-controls"
  *ngIf="travelModes.length"
>
  <div
    *ngFor="let mode of travelModes; let i=index"
    class="control"
    [ngClass]="{'active': mode.travelMode === activeMode}"
    (click)="changeTravelMode(mode)"
    [matTooltip]="'model.gmaps.travel_mode.' + mode.travelMode | translate"
    [matTooltipPosition]="'above'"
  >
    <img
      [src]="mode.iconUrl"
      alt="gmap control icon"
      class="control-icon"
    >
  </div>
</div>
<div
  *ngIf="travelModes.length"
  fxLayout="column"
  fxLayoutAlign="center center"
  class="instructions-container"
  [ngClass]="{'hidden-info': isInfoHidden === true}"
  (click)="isInfoHidden = !isInfoHidden"
>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="info"
    [ngClass]="{'hidden': isInfoHidden === true}"
  >
    <img
      src="/assets/icons/info.svg"
      alt=""
      class="icon"
    >
    <p
      class="text"
    >
      Dați click pe hartă pentru a calcula distanța și timpul de la proiect până la punctul dumneavoastră de interes. Puteți alege
      variante de calcul în funcție de: mașină, mers pe jos sau transport în comun.
    </p>
  </div>
  <span
    class="trigger"
  >
  </span>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-interface/gmaps-interface.component.html